module.exports = __webpack_public_path__ + "static/media/aave-logo.e4e51c48.png";